import { jsx as _jsx } from "react/jsx-runtime";
import { GraficoLinha } from "@monorepo-web/components-library";
import { GraficoLinhaAreaPDF, BaseGraficoPDF } from "@monorepo-web/pdf-generator";
import { FormatTypes } from "@monorepo-web/utils";
import { getLayoutsPDF } from "./layouts";
export default function GraficoRetornoAcumuladoPDF(props) {
    var _a;
    const { data, moneyPrefix, config, assetsApi, layout = 'default' } = props;
    const configLayout = getLayoutsPDF()[layout];
    // substitui ativo com o nome Carteira_retorno
    const assets = assetsApi.map((item) => item === 'Carteira_retorno' ? 'Carteira' : item);
    return (_jsx(BaseGraficoPDF, Object.assign({}, props, { idGraph: "RetornoAcumulado", GraphComponent: GraficoLinha, GraphComponentsProps: {
            data,
            tipo: FormatTypes.percentage,
            assets: assetsApi,
            moneyPrefix: moneyPrefix !== null && moneyPrefix !== void 0 ? moneyPrefix : null
        }, containerWidth: (_a = configLayout.containerWidth) !== null && _a !== void 0 ? _a : 550, containerHeight: 300, createPDFGraph: (svg) => new GraficoLinhaAreaPDF(config, svg, 'Retorno Acumulado', assets, configLayout.sizeRows, configLayout.widthSVG, configLayout.heightSVG, configLayout.alignLegenda) })));
}
